import {
  CHOROPLETH_NO_DATA_FILL,
  getChoroplethPalette,
  type ChoroplethBin,
} from './choroplethDesignSystem';

export const TOTAL_CHARGER_CLASS_COUNT = 7;

/** Fixed integer categories (statewide reference scale; not quantiles). */
const CHARGER_BIN_SPECS: { label: string; min: number; max: number }[] = [
  { label: '0', min: 0, max: 0 },
  { label: '1', min: 1, max: 1 },
  { label: '2', min: 2, max: 2 },
  { label: '3–5', min: 3, max: 5 },
  { label: '6–10', min: 6, max: 10 },
  { label: '11–20', min: 11, max: 20 },
  { label: '21+', min: 21, max: Number.POSITIVE_INFINITY },
];

export function buildTotalChargerBins(_maxValue?: number): ChoroplethBin[] {
  const palette = getChoroplethPalette('neutral', TOTAL_CHARGER_CLASS_COUNT);
  return CHARGER_BIN_SPECS.map((spec, i) => ({
    lower: spec.min,
    upper: spec.max,
    color: palette[i],
    label: spec.label,
  }));
}

/** @deprecated use buildTotalChargerBins */
export function buildTotalChargerLegendBreaks(_maxValue: number): number[] {
  return [0, 1, 2, 5, 10, 20, 21];
}

function chargerBinIndex(value: number): number {
  const v = Math.max(0, Math.round(value));
  for (let i = 0; i < CHARGER_BIN_SPECS.length; i++) {
    const { min, max } = CHARGER_BIN_SPECS[i];
    if (v >= min && v <= max) return i;
    if (max === Number.POSITIVE_INFINITY && v >= min) return i;
  }
  return CHARGER_BIN_SPECS.length - 1;
}

export function totalChargerColor(value: number, bins?: ChoroplethBin[]): string {
  if (!bins || bins.length === 0) {
    return getChoroplethPalette('neutral', 1)[0];
  }
  const idx = chargerBinIndex(value);
  return bins[idx]?.color ?? bins[bins.length - 1].color;
}

export function colorForChargerValue(value: number, bins: ChoroplethBin[]): string {
  if (!Number.isFinite(value)) return CHOROPLETH_NO_DATA_FILL;
  return totalChargerColor(value, bins);
}
